export default "__VITE_ASSET__792539c6__"